export const idID: { [k: string]: string } = {
  'herbal-alternatif': '307831',
  'herbal-alternatif/herbal': '307832',
  'herbal-alternatif/alternatif': '307833',
  nutrisi: '294696',
  'nutrisi/obesitas': '294639',
  'nutrisi/fakta-gizi': '307834',
  'nutrisi/diet': '307835',
  'nutrisi/gizi-olahraga': '307836',
  'nutrisi/berat-badan-turun': '307837',
  'nutrisi/resep-sehat': '307838',
  'nutrisi/tips-makan-sehat': '307839',
  'nutrisi/berat-badan-naik': '307840',
  kebugaran: '307844',
  'kebugaran/kardio': '307845',
  'kebugaran/kelenturan': '307846',
  'kebugaran/keseimbangan': '307847',
  'kebugaran/kekuatan': '307848',
  'kebugaran/cedera-olahraga': '307849',
  'kebugaran/tips-olahraga': '307850',
  'kebugaran/olahraga-lainnya': '307851',
  mental: '307852',
  'mental/kecanduan': '307853',
  'mental/gangguan-kecemasan': '307854',
  'mental/gangguan-makan': '307855',
  'mental/gangguan-mood': '307856',
  'mental/stres': '307857',
  'mental/hubungan-harmonis': '307858',
  'mental/cegah-bunuh-diri': '307859',
  'mental/mental-lainnya': '307860',
  'pola-tidur': '307826',
  'pola-tidur/insomnia': '307863',
  'pola-tidur/gangguan-tidur': '294706',
  'pola-tidur/sleep-apnea': '307864',
  'pola-tidur/tips-tidur': '307865',
  'hidup-sehat': '307871',
  'hidup-sehat/berhenti-merokok': '294712',
  'hidup-sehat/pertolongan-pertama': '294694',
  'hidup-sehat/kebersihan-diri': '307873',
  lansia: '307874',
  'lansia/olahraga-lansia': '307875',
  'lansia/mental-lansia': '307876',
  'lansia/perawatan-lansia': '307826',
  'lansia/gizi-lansia': '307877',
  'lansia/masalah-lansia': '307878',
  kehamilan: '294683',
  'kehamilan/kesuburan': '294684',

  'kehamilan/kandungan': '294685',

  'kehamilan/melahirkan': '294686',

  'kehamilan/perawatan-ibu': '308006',

  parenting: '294665',
  'parenting/bayi': '307885',
  'parenting/bayi/bayi-1-tahun-pertama': '307886',
  'parenting/bayi/menyusui': '294667',
  'parenting/bayi/gizi-bayi': '307887',
  'parenting/bayi/bayi-prematur': '307888',
  'parenting/bayi/perawatan-bayi': '294666',
  'parenting/anak-1-sampai-5-tahun': '307890',
  'parenting/anak-1-sampai-5-tahun/tumbuh-kembang-balita': '307891',
  'parenting/anak-1-sampai-5-tahun/gizi-balita': '307892',
  'parenting/anak-1-sampai-5-tahun/perkembangan-balita': '294670',
  'parenting/anak-6-sampai-9-tahun': '307893',
  'parenting/anak-6-sampai-9-tahun/tumbuh-kembang-anak': '307894',
  'parenting/anak-6-sampai-9-tahun/perkembangan-anak': '307895',
  'parenting/anak-6-sampai-9-tahun/gizi-anak': '307896',
  'parenting/kesehatan-anak': '294671',
  'parenting/kesehatan-anak/imunisasi': '307897',
  'parenting/kesehatan-anak/gejala-anak': '307898',
  'parenting/kesehatan-anak/infeksi-anak': '307899',
  'parenting/kesehatan-anak/malnutrisi': '307900',
  'parenting/kesehatan-anak/gangguan-perkembangan': '307901',
  'parenting/kesehatan-anak/saraf-anak': '307902',
  'parenting/kesehatan-anak/pencernaan-anak': '307903',
  'parenting/kesehatan-anak/kulit-anak': '307904',
  'parenting/kesehatan-anak/pernapasan-anak': '307905',
  'parenting/kesehatan-anak/penyakit-pada-anak': '307906',
  'parenting/remaja': '307908',
  'parenting/remaja/perkembangan-remaja': '307909',
  'parenting/remaja/kesehatan-mental-remaja': '307910',
  'parenting/remaja/kesehatan-remaja': '307911',
  jantung: '307818',
  'jantung/serangan-jantung': '307819',
  'jantung/jantung-koroner': '307820',
  'jantung/hipertensi': '307821',
  'jantung/kolesterol': '307822',
  'jantung/gagal-jantung': '307823',
  'jantung/aritmia': '307824',
  'jantung/jantung-lainnya': '307825',
  pernapasan: '308008',
  'pernapasan/pneumonia': '308009',
  'pernapasan/asma': '294633',
  'pernapasan/tbc': '308010',
  'pernapasan/flu': '294635',
  'pernapasan/ppok': '308011',
  'pernapasan/batuk': '294634',
  'pernapasan/sesak-napas': '308012',
  'pernapasan/bronkitis': '308013',
  'pernapasan/pernapasan-lainnya': '308014',
  kanker: '308015',
  'kanker/kanker-payudara': '294637',
  'kanker/kanker-serviks': '294638',
  'kanker/kanker-ovarium': '308016',
  'kanker/kanker-prostat': '308017',
  'kanker/kanker-paru': '294651',
  'kanker/kanker-lambung': '308018',
  'kanker/kanker-usus-besar': '308019',
  'kanker/kanker-darah': '308020',
  'kanker/kanker-kulit': '294654',
  'kanker/kanker-otak': '308021',
  'kanker/kanker-hati': '294653',
  'kanker/kanker-lainnya': '308022',
  pria: '307912',
  'pria/penyakit-pria': '307913',
  'pria/impotensi': '307914',
  'pria/penis': '307915',
  wanita: '308025',
  'wanita/pcos': '308026',
  'wanita/fibroid-rahim': '294662',
  'wanita/jamur-vagina': '308027',
  'wanita/radang-panggul': '308028',
  'wanita/menopause': '308029',
  'wanita/menstruasi': '308030',
  'wanita/penyakit-wanita': '308031',
  seks: '308032',
  'seks/klamidia': '308033',
  'seks/sifilis': '308034',
  'seks/gonore': '308035',
  'seks/hpv': '308036',
  'seks/trikomoniasis': '308037',
  'seks/hivaids': '294645',
  'seks/penyakit-menular-seksual': '308038',
  'seks/kontrasepsi': '294713',
  'seks/tips-seks': '308039',
  saraf: '308040',
  'saraf/epilepsi': '308043',
  'saraf/alzheimer': '308133',
  'saraf/parkinson': '308134',
  'saraf/stroke': '294643',
  'saraf/sakit-kepala': '308135',
  'saraf/otak-tulang-belakang': '308136',
  'saraf/saraf-tepi': '308137',
  'saraf/saraf-lainnya': '308138',
  alergi: '294641',
  'alergi/makanan': '307916',
  'alergi/kulit': '307917',
  'alergi/hidung-dan-mata': '307918',
  'alergi/alergi-lainnya': '307919',
  infeksi: '308139',
  'infeksi/covid19': '294631',
  'infeksi/herpes': '308140',
  'infeksi/demam-berdarah': '308141',
  'infeksi/tifus': '308142',
  'infeksi/meningitis': '308143',
  'infeksi/infeksi-serangga': '308144',
  'infeksi/infeksi-bakteri': '308145',
  'infeksi/infeksi-virus': '308146',
  'infeksi/infeksi-jamur-parasit': '308147',
  pencernaan: '308150',
  'pencernaan/diare': '294657',
  'pencernaan/konstipasi': '308151',
  'pencernaan/maag': '308152',
  'pencernaan/muntaber': '308153',
  'pencernaan/keracunan-makanan': '308154',
  'pencernaan/usus-buntu': '308155',
  'pencernaan/empedu': '308156',
  'pencernaan/hati': '308157',
  'pencernaan/ambeien': '308158',
  'pencernaan/pencernaan-lainnya': '308159',
  muskuloskeletal: '308160',
  'muskuloskeletal/osteoporosis': '294649',
  'muskuloskeletal/radang-sendi': '308161',
  'muskuloskeletal/myalgia': '308162',
  'muskuloskeletal/kelainan-tulang-belakang': '308163',
  'muskuloskeletal/patah-tulang': '308164',
  'muskuloskeletal/tulang-sendi-lainnya': '308165',
  urologi: '307920',
  'urologi/ginjal': '294642',
  'urologi/prostat': '307921',
  'urologi/kandung-kemih': '307922',
  'urologi/urologi-lainnya': '307923',
  mata: '294693',
  'mata/katarak': '307924',
  'mata/glaukoma': '307925',
  'mata/gangguan-penglihatan': '307926',
  'mata/penyakit-mata': '307927',
  'mata/perawatan-mata': '307928',
  'gigi-mulut': '308044',
  'gigi-mulut/gusi-mulut': '308045',
  'gigi-mulut/gigi': '308046',
  'gigi-mulut/perawatan-oral': '308047',
  'gigi-mulut/perawatan-gigi': '308048',
  'gigi-mulut/gigi-anak': '308049',
  'penyakit-kulit': '308166',
  'penyakit-kulit/jerawat': '294661',
  'penyakit-kulit/psoriasis': '308167',
  'penyakit-kulit/dermatitis': '308168',
  'penyakit-kulit/infeksi-kulit': '308169',
  'penyakit-kulit/perawatan-kulit': '294708',
  'penyakit-kulit/perawatan-rambut': '308170',
  'penyakit-kulit/kulit-lainnya': '308171',
  'penyakit-kulit/perawatan-kuku': '308172',
  diabetes: '294490',
  'diabetes/tipe-1': '307929',
  'diabetes/tipe-2': '307930',
  'diabetes/gula-darah-normal': '307931',
  'kelainan-darah': '308173',
  'kelainan-darah/anemia': '294663',
  'kelainan-darah/hemofilia': '308174',
  'kelainan-darah/sel-darah-putih': '308175',
  'kelainan-darah/thalasemia': '308176',
  'kelainan-darah/trombosit': '308177',
  'kelainan-darah/golongan-darah': '308178',
  'kelainan-darah/darah-lainnya': '308179',
  tht: '307932',
  'tht/telinga': '307933',
  'tht/hidung': '307934',
  'tht/tenggorokan': '307935',
  sehat: '308180',
  'sehat/asuransi': '294703',
  'sehat/berita': '308181',
  'sehat/gejala-umum': '308182',
  'sehat/informasi-kesehatan': '308183',
  'sehat/rumah-sakit': '308184',
  'sehat/tes-kesehatan': '308185',
  'sehat/operasi': '308186',
}

const LanguageMapping: {
  [locale: string]: {
    [slug: string]: string
  }
} = {
  'id-ID': idID,
}

export const getLocaleVideoAdMappingFromSlug = (
  locale: string,
  slug: string,
) => {
  if (!LanguageMapping[locale]) return null
  let cleanedSlug = slug.split('/').filter(Boolean).join('/')
  while (cleanedSlug) {
    const foundValue = LanguageMapping[locale][cleanedSlug]
    if (foundValue) return foundValue
    const parentSlugs = cleanedSlug.split('/')
    parentSlugs.pop()
    cleanedSlug = parentSlugs.join('/')
  }
  return null
}
